




































































import { mapState } from 'vuex';
import { env } from '@zyf2e/adapt';
import { IspecialistDetail, IpostStartConsultParam, IGetEquityPackDetailResult } from '@/store/specialist/index.d';
import { commitSetSetSpecialistDetail, dispatchGetEquityPackDetail, dispatchPlaceOrder } from '@/store/specialist';
import { SPECIALIST } from '@/constant';
import Component from 'vue-class-component';
import Webview from '@/webview';
import { dispatchCheckIMActivity } from '@/store/user';
import { payHandle, getPathEnv } from '@/utils';
import Tips from './tips.vue';
import { debug } from 'console';

@Component({
  computed: {
    ...mapState(SPECIALIST, ['specialist'])
  },
  components: {
    Tips
  }
})
export default class ClinicPayment extends Webview {
  tradeNo = '';

  specialist!: IspecialistDetail;

  isShowNeedCoinTip = false;

  specialistRequest: IpostStartConsultParam = {
    doctorId: 0,
    areaName: ''
  };

  // specialist: Partial<IspecialistDetail> = {};

  consultId!: number;

  checkedConfirmation = true;

  env = env;

  equityItem: IGetEquityPackDetailResult = {
    userEquityPackId: '0',
    packName: '',
    num: 0,
    residueNum: 0,
    startTime: 0,
    endTime: 0,
    archiveId: '',
    archiveName: ''
  };

  sourceId = '';

  get isOriginPrice() {
    const { firstConsultFree, memberFree, coin } = this.specialist;
    return coin === 0 || firstConsultFree || memberFree;
  }

  async created() {
    window.onpageshow = (event: { persisted: any }) => {
      // event.persisted 判断浏览器是否有缓存, 有为true, 没有为false. 解决小程序跳转第三方页面返回因为缓存原因唤不起支付的问题
      if (event.persisted && env.inWechatMiniProgram) {
        window.location.reload();
      }
    };
    await this.getDetail();
    this.registFunc({
      type: 'payMent',
      func: this.getDetail
    });
  }

  async getDetail() {
    const { id } = this.$route.params;

    this.specialistRequest.doctorId = Number.parseInt(id, 0);
    this.specialistRequest.areaName = this.location;
    this.ZYToast.setOnceConfig({ noToast: true });

    const specialistRequest = { ...this.specialistRequest };
    if (this.sourceId) {
      specialistRequest.sourceId = this.sourceId;
    }
    const { tradeNo, doctorInfo, consultId, sourceId } = await dispatchPlaceOrder(this.$store, this.specialistRequest);
    this.tradeNo = tradeNo;

    this.sourceId = sourceId as string;

    if (sourceId) {
      this.equityItem = await dispatchGetEquityPackDetail(this.$store, {
        userEquityPackId: sourceId,
        equityItem: 'EXPERT_INQUIRY',
        doctorId: specialistRequest.doctorId
      });
    }

    this.ZYToast.clearOnceConfig();

    commitSetSetSpecialistDetail(this.$store, doctorInfo);
    this.consultId = consultId;
  }

  async pay(): Promise<void> {
    if (!this.checkedConfirmation) {
      this.$toast('请确认阅读并同意《知情同意书》');
      return;
    }
    const { doctorId, memberFree, firstConsultFree, price, coin } = this.specialist;
    if (!doctorId) {
      return;
    }
    
    // 在小程序环境下，非免费问诊需要提示下载App
    // if (env.inWechatMiniProgram) {
    //   const toastMsg = '请前往智云健康APP进行在线问诊';
    //   const isFree = memberFree || firstConsultFree || (!price && !coin);

    //   if (!isFree) {
    //     this.$toast(toastMsg);
    //     return;
    //   }
    // }

    this.ZYToast.setOnceConfig({ noToast: true });
    
    console.log(99001212);

    try {
      this.$toast.loading({ duration: 0 });
      const { allow } = await dispatchCheckIMActivity(this.$store, { toId: doctorId });
      if (allow) {
        this.$toast.clear(true);
        this.ZYToast.clearOnceConfig();
        this.adapter.goIM({ toId: doctorId.toString() });
        return;
      }
    } catch ({ code, message }) {
      // this.adapter.goIM({ toId: doctorId.toString() });
      this.$toast.fail(message);
    }

    // TODO 小程序里报错，暂时不考虑
    // if (!this.env.inWechatMiniProgram) {
    //   window.history.replaceState(
    //     null,
    //     '',
    //     `${process.env.VUE_APP_STATIC}/f2e/more-project/${getPathEnv()}patient-consulted-list/#/`
    //   );
    // }

    this.$toast.clear(true);
    this.ZYToast.clearOnceConfig();
    payHandle({ tradeNo: this.tradeNo, doctorId });
  }

  /* eslint-disable class-methods-use-this */
  toLink() {
    window.location.href = 'https://static.91jkys.com/tms/wenzhenzhiqingtongyishu/index.html';
  }
}
